import React from "react";
import LeadSection from "../pageComponents/ordersAndLeads/leads/LeadSection";

export default function LeadPage(){
    return(
        <div className="mt-[10vh]">
          <LeadSection/>
        </div>
    );
}